<template>
  <div
    v-if="chart"
    class="the-time-spent-chart"
    data-help-title="Lernminuten pro Tag"
    data-help="Hier siehst du wieviele Lernminuten du pro Tag aufgewendet hast."
  >
    <GChart
      v-if="chart.length > 1"
      type="LineChart"
      :data="chart"
      :options="chartOptions"
    />
    <div v-else class="message">
      Beantworte Fragen und verbringe Zeit in der App um diesen Bereich zu
      aktivieren
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GChart } from "vue-google-charts";

export default {
  name: "TheTimeSpentChart",
  components: { GChart },
  data() {
    return {
      chartOptions: {
        title: "Lernminuten pro Tag",
        titleTextStyle: {
          color: "#ffffff",
          fontSize: 16,
        },
        width: "95%",
        chartArea: {
          left: 5,
          width: "95%",
        },
        isStacked: true,
        legend: {
          position: "top",
          textStyle: { color: "#ffffff" },
          alignment: "end",
        },
        colors: ["rgb(57, 158, 139)", "#ffffff"],
        hAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
        },
        vAxis: {
          baseline: 0,
          baselineColor: "#ffffff",
          gridlineColor: "#ffffff",
          minorGridlines: { color: "#ffffff" },
          textStyle: { color: "#ffffff" },
          minValue: 0,
        },
        //backgroundColor: 'rgb(57, 158, 139)',
        backgroundColor: "rgb(50, 64, 80)",
        pointsVisible: true,
      },
    };
  },
  computed: {
    chart() {
      if (this.me && this.me.time_data) {
        let data = this.me.time_data.map((d) => {
          let parts = d.date.split("-");
          //let date = "Date(" + parseInt(parts[0]) + ", " + parseInt(parts[1]) + ", " + parseInt(parts[2]) + ")";
          //let realDate = Date(parts[0], parts[1], parts[2]);
          //let newRealDate = new Date(parts[0], parts[1], parts[2]);
          let displayDate = parts[2] + "." + parts[1];
          return [
            displayDate,
            parseInt(d.time, 10) / 1000 / 60,
            "point { size: 3; shape-type: circle; fill-color: #ffffff; }",
          ];
        });
        return [
          ["Datum", "Minuten", { type: "string", role: "style" }],
          ...data,
        ];
      }
      return [];
    },
    ...mapGetters(["me"]),
  },
};
</script>

<style lang="scss" scoped>
.the-time-spent-chart {
  background: $blue;
  border-bottom: 5px solid #ffffff;
  padding: 10px;

  .message {
    color: #ffffff;
    padding: 20px;
    text-align: center;
  }
}
</style>
